import { Injectable } from '@angular/core';
import { Actions, createEffect, ofType } from '@ngrx/effects';
import { catchError, concatMap, switchMap } from 'rxjs/operators';
import * as fromShared from '../../shared';
import { LoggingService } from '../../shared/services/logging/logging.service';
import { CheckupService } from '../checkup.service';
import * as fromCheckup from './checkup.actions';

@Injectable()
export class CheckupEffects {
    constructor(
        private log: LoggingService,
        private actions$: Actions,
        private service: CheckupService
    ) {}

    getCheckup$ = createEffect(() =>
        this.actions$.pipe(
            ofType(fromCheckup.getCheckups),
            switchMap(action =>
                this.service.get(action.ProcessID, action.EmployeeListID).pipe(
                    concatMap(checkups =>
                        checkups
                            ? [
                                  fromCheckup.clearCheckups(),
                                  fromCheckup.loadCheckups({
                                      checkups
                                  })
                              ]
                            : [
                                  fromShared.Errors.handleNullDataError(
                                      checkups,
                                      'Checkups'
                                  )
                              ]
                    ),
                    catchError(fromShared.Errors.handleServiceError)
                )
            )
        )
    );
}
